import MentoringBoyIcon from './MentoringBoyIcon.vue';

export default MentoringBoyIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/boy/index.ts